import type React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as baseDealActionCreators from '@makemydeal/dr-dash-store/actions/baseDealActionCreators';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import * as programsSelectors from '@makemydeal/dr-dash-store/selectors/programsSelectors';
import { DealTabs } from '@makemydeal/dr-shared-types';

export const PROGRAM_FIELD_LABEL = 'Program';
const UPQ_WARNING_TOOLTIP =
    'was applied to start this deal. One or more values may have been manually updated and  no longer match the original program terms.';

export const useProgramField = ({ onProgramSlideOutOpen }: { onProgramSlideOutOpen?: () => void }) => {
    const dispatch = useDispatch();
    const isUserProgramQuotes = useSelector(offerReduxSelectors.getIsUserProgramQuotes);
    const lenderProgramDisplay = useSelector(programsSelectors.getLenderProgramDisplay);

    const handleClick = () => {
        if (onProgramSlideOutOpen) {
            onProgramSlideOutOpen();
        } else {
            dispatch(baseDealActionCreators.handleTabChange(DealTabs.INCENTIVES));
        }
    };

    const handleLabelKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClick();
        }
    };

    return {
        label: PROGRAM_FIELD_LABEL,
        value: lenderProgramDisplay,
        upqWarning: isUserProgramQuotes && lenderProgramDisplay ? `${lenderProgramDisplay} ${UPQ_WARNING_TOOLTIP}` : undefined,
        onLabelActivate: handleClick,
        onLabelKeyDown: handleLabelKeyDown
    };
};
